<template>
    <div class="container pr-3 pl-3 margin-3">
        <div class="mb-5 pr-3 pl-3" style="margin-top: 5%">
            <div class=" col-12 logo-side text-center text-head">
                <img class=" mt-md-3 logo-size"
                     src="../assets/logo-login.png">
               ลงทะเบียนสำหรับเข้าสู่ระบบ
            </div>
            <div class="mt-4 offset-sm-2 col-sm-8 offset-1 col-10">
                <div class="pt-4 mt-0 register-form">
                    <div class="row">
                            <div class="offset-md-2 offset-1 col-md-8 col-10">
                                <div class="form-group">
                                    <label>ชื่อจริง</label>
                                    <input v-model="form.first_name"
                                           type="text" class="form-control"  >
                                </div>
                                <div class="form-group">
                                    <label >นามสกุล</label>
                                    <input  v-model="form.last_name"
                                            type="text" class="form-control" >
                                </div>
                                <div class="form-group">
                                    <label >เลขประจำตัวประชาชน</label>
                                    <input  v-model="form.username"
                                            type="text" class="form-control" maxlength="13">
                                </div>
                                <div class="form-group">
                                    <label >เบอร์โทรศัพท์</label>
                                    <input  v-model="form.phone_number"
                                            type="number" class="form-control" maxlength="10" >
                                </div>
                                <div class="form-group">
                                    <label >เลือกระดับผู้ใช้</label>

                                    <select v-model="form.user_type_id"
                                            class="browser-default custom-select">
                                        <option value="" disabled hidden>ระดับผู้ใช้</option>
                                        <option value="1">ระดับเขต</option>
                                        <option value="2">ระดับจังหวัด</option>
                                        <option value="3">ระดับอำเภอ</option>
                                    </select>

                                </div>
                                <template v-if="form.user_type_id == 1">
                                    <div class="form-group">
                                        <label >ระดับเขต</label>
                                        <select v-model="form.area_id"
                                                class="browser-default custom-select">
                                            <option value="" disabled hidden>ระดับเขต</option>
                                            <option value="1">เขต 1</option>
                                            <option value="2">เขต 2</option>
                                            <option value="3">เขต 3</option>
                                            <option value="4">เขต 4</option>
                                            <option value="5">เขต 5</option>
                                            <option value="6">เขต 6</option>
                                            <option value="7">เขต 7</option>
                                            <option value="8">เขต 8</option>
                                            <option value="9">เขต 9</option>
                                            <option value="10">เขต 10</option>
                                            <option value="11">เขต 11</option>
                                            <option value="12">เขต 12</option>
                                            <option value="13">สปคม</option>
                                        </select>
                                    </div>
                                </template>
                                <template v-if="form.user_type_id == 2">
                                    <div class="form-group">
                                        <label >จังหวัด</label>

                                        <multiselect
                                                v-model="form.province"
                                                :options="optionProvince"
                                                label="name"
                                                select-label=""
                                                selectedLabel=""
                                                deselect-label=""
                                                placeholder="เลือกจังหวัด"
                                                track-by="name">
                                        </multiselect>
                                    </div>
                                </template>
                                <template v-if="form.user_type_id == 3">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <label >จังหวัด</label>
                                                <multiselect
                                                        v-model="form.province"
                                                        @input="getDistricts(form.province)"
                                                        :options="optionProvince"
                                                        label="name"
                                                        select-label=""
                                                        selectedLabel=""
                                                        deselect-label=""
                                                        placeholder="เลือกจังหวัด"
                                                        track-by="name">
                                                </multiselect>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <label >อำเภอ</label>
                                                <multiselect
                                                        v-model="form.district"
                                                        :options="optionDistrict"
                                                        label="name"
                                                        select-label=""
                                                        selectedLabel=""
                                                        deselect-label=""
                                                        placeholder="เลือกอำเภอ"
                                                        track-by="name"
                                                        :allow-empty="false" >
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <div class="mt-4 form-group">

                                    <label  for="file-upload" class="custom-file-upload">
                                        <i class="fas fa-plus"></i> อัพโหลดรูปข้าราชการ/ประชาชน
                                    </label>
                                    <input  @change="imageFileUpload"
                                             id="file-upload" type="file"/>
                                </div>
                            </div>
                        </div>
                </div>

                <div class="pt-4 pb-3 text-center" >
                    <b-button @click="saveUser"
                              type="submit" variant="dark" class="btn-submit">
                        บันทึก
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Multiselect from 'vue-multiselect';

    export default {
        name: "RegisterView",
        props: {
            id: { default: null }
        },
        components: {
            Multiselect
        },
        created(){
            this.checkLogin();
            this.$store.dispatch("Common/setProvince");
            this.$store.dispatch("Auth/clearFormData");
        },
        computed: {
            ...mapState({
                form : state=>{
                    return state.Auth.form;
                },
                optionProvince : state=>{
                    return state.Common.provinces;
                },
                optionDistrict : state=>{
                    return state.Common.districts;
                },
                user_login : state=>{
                    return state.Auth.user_login
                }
            })
        },
        data() {
            return {
                optionsUserType: [
                    {name: 'ส่วนกลาง', value: '1'},
                    {name: 'ส่วนจังหวัด', value: '2'},
                    {name: 'ส่วนอำเภอ', value: '3'},
                ]
            };
        },
        methods:{
            checkLogin(){
                if(this.user_login == null){
                    this.$router.push({
                        name:"RegisterView"
                    });
                }
                else if(this.user_login != null){
                    this.$router.push({
                        name:"Status"
                    });
                }
            },
            getDistricts(province){
                if(province){
                    this.form.district = null;
                    this.$store.dispatch('Common/setDistrict',province.code);
                }
            },
            imageFileUpload:function (event) {
                let input = event.target;
                this.form.avatar = input.files[0];
            },
            saveUser(){
                if(!this.form.first_name ){
                    alert("กรุณากรอกชื่อจริง");
                }
                else if(!this.validName(this.form.first_name)){
                    alert("กรุณากรอกชื่อจริงให้ถูกต้อง");
                }
                else if(!this.form.last_name ){
                    alert("กรุณากรอกนามสกุล");
                }
                else if(!this.validName(this.form.last_name)){
                    alert("กรุณากรอกนามสกุลให้ถูกต้อง");
                }
                else if(!this.form.username ){
                    alert("กรุณากรอกเลขบัตรประจำตัวประชาชน");
                }
                else if(!this.validUsername(this.form.username)){
                    alert("กรุณากรอกเลขบัตรประจำตัวประชาชนให้ถูกต้อง");
                }
                else if(!this.form.phone_number ){
                    alert("กรุณากรอกเบอร์โทรศัพท์");
                }
                else if(!this.validPhoneNumber(this.form.phone_number)){
                    alert("กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง เช่น 0102345678");
                }
                else if(!this.form.user_type_id ){
                    alert("กรุณาเลือกระดับผู้ใช้");
                }
                else if(this.form.user_type_id == 1 && !this.form.area_id  ){
                    alert("กรุณาเลือกเขตสุขภาพ");
                }
                else if((this.form.user_type_id == 2 || this.form.user_type_id == 3) && !this.form.province ){
                    alert("กรุณาเลือกจังหวัด",);
                }
                else if(this.form.user_type_id == 3 && !this.form.district ){
                    alert("กรุณาเลือกอำเภอ");
                }
                else{
                    if(this.form.province){
                        this.form.province_id = this.form.province.id;
                    }
                    if(this.form.district ){
                        this.form.district_id = this.form.district.id;
                    }

                    if(!this.form.avatar){
                        this.form.avatar = "";
                    }
                    let data = {
                        first_name: this.form.first_name,
                        last_name: this.form.last_name,
                        username: this.form.username,
                        phone_number: this.form.phone_number,
                        user_type_id: this.form.user_type_id,
                        area_id: this.form.area_id,
                        province_id: this.form.province_id,
                        district_id: this.form.district_id,
                        avatar : this.form.avatar,
                    };
                    let formData = new FormData();
                    formData.append('first_name',data.first_name);
                    formData.append('last_name',data.last_name);
                    formData.append('username',data.username);
                    formData.append('phone_number',data.phone_number);
                    formData.append('user_type_id',data.user_type_id);
                    formData.append('area_id',data.area_id);
                    formData.append('province_id',data.province_id);
                    formData.append('district_id',data.district_id);
                    formData.append('avatar',data.avatar);
                    if(this.id){
                        formData.append("_method",'put');
                    }
                    this.$store.dispatch("Auth/register",formData)
                    this.goToLogin();
                }
            },
            goToLogin(){
              this.$swal('สมัครเรียบร้อย <br>' +
                'username:' + this.form.username + ' <br>'+
                'password:' + this.form.phone_number );
                this.$router.push({
                    name:"LoginView"
                });
            },
            validName: function (name) {
                var re = /[^0-9]$/;
                if(name.match(re)){
                    return true;
                }
                else{
                    return false;
                }
            },
            validUsername: function (username) {
                var re = /[0-9]{13}$/;
                if(username.match(re)){
                   return true;
                }
                else{
                    return false;
                }
            },
            validPhoneNumber: function (phone_number) {
                var re = /^[0][0-9]{9}$/;
                if(phone_number.match(re)){
                    return true;
                }
                else{
                    return false;
                }
            }
        }
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }
    .custom-file-upload {
        background-color: #E5E5E5;
        color: #006738;
        border: 2px solid gray;
        padding: 10px 10px 3px 10px;
        border-radius: 7px;
        font-size: 24px;
        font-weight: bold;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        display: inline-block;
        cursor: pointer;
    }

    .register-form{
        background-color: #006738;
        color: white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 24px;
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 2px;
    }
    .logo-size{
        height: 110px;
    }

    .text-head{
        color: #006738;
        font-size: 38px;
    }

    .register-form input{
        font-size: 22px;
        font-weight: 400;
    }
    .register-form select{
        font-size: 22px;
        font-weight: 400;
    }

    .btn-submit{
        background-color: #006738;
        color: white;
        font-size: 25px;
        font-weight: 700;
        padding: 7px 25px 3px 25px;
    }

    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }

    .btn-upload {
        background-color: #E5E5E5;
        color: #006738;
        border: 2px solid gray;
        padding: 10px 10px 3px 10px;
        border-radius: 7px;
        font-size: 24px;
        font-weight: bold;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    @media only screen and (max-width: 767px) {
        .logo-size{
            height: 90px;
        }

        .text-head{
            font-size: 30px;
        }

    }

    @media only screen and (max-width: 499px) {
        .logo-size{
            height: 70px;
        }

        .text-head{
            font-size: 23px;
        }

        .btn-submit{
            font-size: 17px;
        }

        .register-form{
            font-size: 18px;
        }

        .register-form input {
            font-size: 18px;
        }
        .register-form select{
            font-size: 18px;
        }

        .custom-file-upload {
            font-size: 16px;
        }

        /*.multiselect{*/
        /*    font-size: 18px !important;*/
        /*}*/
        /*.multiselect__input{*/
        /*    font-size: 18px !important;*/
        /*}*/
        /*.multiselect__single {*/
        /*    font-size: 18px !important;*/
        /*}*/
    }
    @media only screen and (max-width: 350px) {

        .text-head{
            font-size: 20px;
            text-align: center;
        }

    }


</style>
